module.exports = __webpack_public_path__ + "static/tomsguide-42c6b8eb5b1fa4879fb9c5e7c26de6d8.png";